import { useCallback, useEffect, useRef, useState } from 'react';

import formatDistance from 'date-fns/formatDistance';
import pt from 'date-fns/locale/pt';
import { toast } from 'react-toastify';

import Actions from '~/components/Actions';
import Button from '~/components/Button';
import Header from '~/components/Header';
import Pagination from '~/components/Pagination';
import Table from '~/components/Table';
import TableActions from '~/components/TableActions';
import PrivateLayout from '~/layouts/Private';
import api from '~/services/api';

import Form from './Form';
import { Container, Capitalize } from './styles';

const INITIAL_PERSONS = {
  data: [],
  page: 0,
  perPage: 0,
  total: 0,
  lastPage: 0,
};

const Person = () => {
  const formRef = useRef();

  const [persons, setPersons] = useState(INITIAL_PERSONS);

  const getPersons = useCallback(async (page = 1) => {
    try {
      const response = await api.get(
        `persons?page=${page}&perPage=10&active=true&orderBy=updated_at DESC`
      );

      setPersons(response.data);
    } catch (error) {
      toast.error('Erro ao buscar pessoas...');
      setPersons(INITIAL_PERSONS);
    }
  }, []);

  useEffect(() => {
    getPersons();
  }, [getPersons]);

  const handleClickOpenForm = () =>
    formRef.current.setData({
      type: 'C',
    });

  const handleClickEdit = (data) => formRef.current.setData(data);

  const handleOnCloseForm = (reload) => {
    if (reload) getPersons();
  };

  const columns = [
    {
      key: 'name',
      label: 'Nome',
      format: (name) => <Capitalize>{name}</Capitalize>,
    },
    {
      key: 'type',
      label: 'Tipo',

      format: (value) => {
        const types = {
          C: 'Contato',
          F: 'Física',
          J: 'Jurídica',
        };

        return types[value];
      },
    },
    {
      key: 'city',
      label: 'Cidade',
      format: (name) => <Capitalize>{name}</Capitalize>,
    },
    {
      key: 'updated_at',
      label: 'Atualizado',
      format: (value) =>
        formatDistance(new Date(value), new Date(), {
          locale: pt,
          addSuffix: true,
        }),
    },
    {
      label: '',
      width: 50,
      format: (detail) => {
        return <TableActions onEdit={() => handleClickEdit(detail)} />;
      },
    },
  ];

  return (
    <PrivateLayout>
      <Container>
        <Header title="Pessoas" total={persons.total} />
        <Actions align="flex-end">
          <Button label="Nova pessoa" onClick={handleClickOpenForm} />
        </Actions>
        <Form ref={formRef} onClose={handleOnCloseForm} />
        <Table columns={columns} rows={persons.data} />
        <Pagination
          onChange={getPersons}
          page={persons.page}
          perPage={persons.perPage}
          total={persons.total}
          lastPage={persons.lastPage}
          position="flex-end"
        />
      </Container>
    </PrivateLayout>
  );
};

export default Person;
